import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { getSliderImgs } from "../Participant/Home/components/slider";
import LogInForm from "./components/LogInForm";
import ResendActivationPopup from "./components/ResendActivationPopup";
import SignupPopup from "./components/SignupPopup";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const LogIn = ({ template, program, banner_status }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [ssoToken] = useState(searchParams.get('sso-token') || null);
  const [showSignup, setShowSignup] = useState(false);
  const [showResend, setShowResend] = useState(false);

  useEffect(() => {
    document.body.classList.add('login-active');
    return () => document.body.classList.remove('login-active');
  }, []);

  localStorage.removeItem('promo_closed');
  if (!template) return t("loading");

  const slides = getSliderImgs(template);
  const welcome = { __html: template?.welcome_message ? template.welcome_message : t("welcome_message") };
  const hideSignup = String(program?.hide_sign_up_form) === "1";
  const showResendLink = String(program?.rootProgram?.resend_activation_link) !== "0";

  const BrandPanel = () => {
    // ICOV3-1468: disable autoplay on mobile to avoid iOS Safari memory pressure
    const isDesktop = typeof window !== 'undefined' && window.matchMedia('(min-width: 465px)').matches;

    if (!slides.length) {
      return (
        <div className="login-brand login-brand--plain">
          <div className="login-brand__copy" dangerouslySetInnerHTML={welcome} />
        </div>
      );
    }

    return (
      <div className="login-brand">
        <div className="login-brand__image-wrap">
          <Carousel
            swipeable={false}
            draggable={false}
            showDots={false}
            responsive={{
              all: { breakpoint: { max: 4000, min: 0 }, items: 1 },
            }}
            infinite
            autoPlay={isDesktop && slides.length > 1}
            autoPlaySpeed={4000}
            arrows={false}
            transitionDuration={800}
            containerClass="login-brand__carousel"
            itemClass="login-brand__slide"
          >
            {slides.map((item, i) => (
              <div
                key={i}
                className="login-brand__img-frame"
                style={{ "--login-brand-slide": `url("${item.src}")` }}
              >
                <img src={item.src} alt="" className="login-brand__img" />
              </div>
            ))}
          </Carousel>
          <div className="login-brand__overlay" />
        </div>
        {welcome.__html && (
          <div className="login-brand__welcome" dangerouslySetInnerHTML={welcome} />
        )}
      </div>
    );
  };

  return (
    <div className="login-page">
      <div className="login-page__visual">
        <BrandPanel />
      </div>

      <div className="login-page__form-panel">
        <div className="login-page__form-inner">
          {template?.small_logo && (
            <div className="login-page__form-logo">
              <img
                src={`${process.env.REACT_APP_API_STORAGE_URL}/${template.small_logo}`}
                alt="logo"
              />
            </div>
          )}
          <div className="login-page__heading-group">
            <h1 className="login-page__heading">Welcome back</h1>
            <p className="login-page__subheading">Sign in to your rewards program</p>
          </div>

          <LogInForm
            showResendActivationLink={showResendLink}
            onOpenResendActivation={() => setShowResend(true)}
          />

          {!hideSignup && (
            <div className="login-page__alt-actions">
              <button type="button" className="login-page__alt-link" onClick={() => setShowSignup(true)}>
                Don't have an account? <strong>Sign up</strong>
              </button>
            </div>
          )}
        </div>
      </div>

      {showSignup && <SignupPopytup onCancelHandler={() => setShowSignup(false)} />}
      {showResend && <ResendActivationPopup onCancelHandler={() => setShowResend(false)} />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  program: state.domain?.program,
  template: state.domain?.program?.template,
  banner_status: state.domain?.banner_status?.banner_status,
});

export default connect(mapStateToProps)(LogIn);
